import { I18nContext, localizePath } from 'gatsby-plugin-i18n'
import { useContext, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { breakpoints } from 'swp-components/lib/assets/config/style'
import { Container } from 'swp-components/lib/components/bootstrap'
import { Button } from 'swp-components/lib/components/common'
import { PackageTypeCard } from 'swp-components/lib/components/mobile-package'

import useColumns from '@/hooks/use-columns'
import generateSliderOptions from '@/util/generate-slider-options'

import Slider from '../slider'
import style from './style'

const MobilePackageType = ({ type, packageTypes, ...props }) => {
  let { locale, defaultLocale } = useContext(I18nContext)

  packageTypes = packageTypes.map(packageType => ({
    ...packageType,
    detailLink: {
      url: localizePath(
        `/truemoveh/${type}/${packageType.slug}`,
        locale,
        defaultLocale
      ),
      newTab: false,
    },
  }))

  let sliderOptions = generateSliderOptions(280)

  let [rows, setRows] = useState(1)

  let { columns } = useColumns([
    { value: breakpoints.sm, columns: 2 },
    { value: breakpoints.lg, columns: 3 },
    { value: breakpoints.xl, columns: 4 },
  ])

  let centered = packageTypes.length < columns

  let visiblePackageTypes = packageTypes.slice(0, columns * rows)

  return (
    <Container {...props}>
      <div css={style.sliderWrapper}>
        <Slider options={sliderOptions}>
          {packageTypes.map(packageType => (
            <div
              key={packageType.id}
              css={style.box}
              style={{ width: `${100 / columns}%` }}
            >
              <PackageTypeCard css={style.card} packageType={packageType} />
            </div>
          ))}
        </Slider>
      </div>
      {packageTypes.length < columns - 1 && (
        <div className="d-flex justify-content-center mt-3">
          <Button variant="outlined" onClick={() => setRows(rows + 2)}>
            <FormattedMessage id="viewMore" defaultMessage="View More" />
          </Button>
        </div>
      )}
    </Container>
  )
}

export default MobilePackageType
